import api from './api'

export const configService = {
  getAll: () => api.get('/config'),
  getByKey: (key: string) => api.get(`/config/${key}`),
  create: (data: { clave: string; valor: string; descripcion?: string }) => api.post('/config', data),
  update: (key: string, data: { valor: string; descripcion?: string }) => api.put(`/config/${key}`, data),
  delete: (key: string) => api.delete(`/config/${key}`),
  recalculateIrpf: (data?: { from_date?: string }) => api.post('/config/recalculate-irpf', data || {}),
}

export default configService

